"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleHelper = void 0;
var environment_helper_1 = require("./environment.helper");
exports.ConsoleHelper = {
    log: function () {
        var attrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attrs[_i] = arguments[_i];
        }
        if ((environment_helper_1.EnvironmentHelper.isLocalEnvironment() &&
            !environment_helper_1.EnvironmentHelper.isRunningTest()) ||
            this.isClientLogsEnabled()) {
            console.log.apply(console, attrs);
        }
    },
    info: function () {
        var attrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attrs[_i] = arguments[_i];
        }
        if ((!environment_helper_1.EnvironmentHelper.isProductionEnvironment() &&
            !environment_helper_1.EnvironmentHelper.isRunningTest()) ||
            this.isClientLogsEnabled()) {
            console.info.apply(console, attrs);
        }
    },
    warn: function () {
        var attrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attrs[_i] = arguments[_i];
        }
        if ((!environment_helper_1.EnvironmentHelper.isProductionEnvironment() &&
            !environment_helper_1.EnvironmentHelper.isRunningTest()) ||
            this.isClientLogsEnabled()) {
            console.warn.apply(console, attrs);
        }
    },
    error: function () {
        var attrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attrs[_i] = arguments[_i];
        }
        if (!environment_helper_1.EnvironmentHelper.isRunningTest() || this.isClientLogsEnabled()) {
            console.error.apply(console, attrs);
        }
    },
    isClientLogsEnabled: function () {
        return (environment_helper_1.EnvironmentHelper.isClientSide() &&
            "isClientLogsEnabled" in window &&
            !!window.isClientLogsEnabled);
    },
};
